import { IRootState } from '../../app/store';

export const selectSendSkillsEmailAsyncStatus = (state: IRootState) =>
    state.emails.sendPatientEducationEmailAsyncStatus;
